import './index.css';
import { isValidElement } from 'react';

const MAX_ICONS = 5;
const isNavigationBarComponent = (component) => isValidElement(component) && typeof component.type === 'function' && 'isNavigationBar' in component.type;

export { MAX_ICONS, isNavigationBarComponent };
//# sourceMappingURL=types.js.map
